import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Oval } from "react-loading-icons";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { TableBody, TableCell, TableRow } from "@material-ui/core";
import moment from "moment";
import { TextField } from "@material-ui/core";
import { eventBus } from "../services/eventBusService";
import { DashboardHeader } from "../cmp/DashboardHeader";
import { crmService } from "../services/crmService";
import { confirmAlert } from "react-confirm-alert";
import {
  loadCrms,
  removeCrm,
  sendSaisie2,
  updateCrmDateMaj2,
  saveCrm,
  setEditCrm,
  setEditCrmSoldCred,
  setEditCrmSoldDeb,
  setEditCrmuSoldCred,
  setEditCrmuSoldDeb,
} from "../store/actions/crmAction";
import {
  Row,
  Col,
  Card,
  Button,
  CardImg,
  CardBody,
  CardTitle,
  CardFooter,
} from "reactstrap";
import { Modal2 } from "./Modal2";
import classnames from "classnames";
import {
  Table,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import Select from "react-select";
import {
  loadUsers,
  saveUser,
  sendEmail,
  setEditUser,
  loadAdmin,
  keepEvennement2,
  sendEvennement2,
  updateEvennement2,
  removeEvennement2,
} from "../store/actions/userAction";
import { DashboardHeaderCollecteur } from "../cmp/DashboardHeaderCollecteur";
import { DashboardHeaderEvennements } from "../cmp/DashboardHeaderEvennements";
import { Modal6Fournisseurs } from "./Modal6Fournisseurs";
import { Modal8Evennement } from "./Modal8Evennement";
import { format } from "path";
import { SITE_ADRESS, SENDGRID_MAILFROM1 } from "../config";

export function HistoEvennements() {
  const dispatch = useDispatch();
  const crms = useSelector((state) => state.crmReducer.crms);
  const users = useSelector((state) => state.userReducer.users);
  const crmIdxEdited = useSelector((state) => state.crmReducer.crmIdxEdited);
  const userIdxEdited = useSelector((state) => state.userReducer.userIdxEdited);
  // const crmsSoldDeb = useSelector((state) => state.crmReducer.crmsSoldDeb);
  // const crmsSoldCred = useSelector((state) => state.crmReducer.crmsSoldCred);
  // const crmUSoldDeb = useSelector((state) => state.crmReducer.crmUSoldDeb);
  // const crmUSoldCred = useSelector((state) => state.crmReducer.crmUSoldCred);
  const loggedInUser = useSelector((state) => state.userReducer.loggedInUser);
  const filterCrm = useSelector((state) => state.crmReducer.filterCrm);
  const [openFlag, setOpenFlag] = useState(false);
  const [openFlag3, setOpenFlag3] = useState(false);
  const [openFlag4, setOpenFlag4] = useState(false);
  const [crmId, setCrmId] = useState("");
  const [crmId2, setCrmId2] = useState("");
  const [rep1, setRep1] = useState("");
  const [rep2, setRep2] = useState("");
  const [rep3, setRep3] = useState("");
  const [rep4, setRep4] = useState("");
  const [participantId, setParticipantId] = useState(null);
  const [totalParticipant, setTotalParticipant] = useState("");
  const [switched, setswitched] = useState(false);
  const [afficheListe, setAfficheListe] = useState(false);
  const [afficheParticipe, setAfficheParticipe] = useState(false);
  const [bolSave, setBolsave] = useState(true);

  // const [userAdmin, setUserAdmin] = useState(null);
  const [evennements, setEvennements] = useState([]);
  const [ev1, setEv1] = useState(null);

  // const [compteur, setCompteur] = useState(0);
  // let compteur = 0;
  //let titleEv = "";
  //let ev1;
  let soldeTotalDebit2 = "";
  let soldeTotalCredit2 = "";
  useEffect(() => {
    const unsubscribe = eventBus.on("editing", () => {
      setOpenFlag(false);
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    async function loadData() {
      soldeTotalDebit2 = "0";
      soldeTotalCredit2 = "0";

      const evennementsData = await keepEvennement2();
      setEvennements(evennementsData);

      await dispatch(loadCrms());
    }

    loadData();
  }, [openFlag, openFlag3, openFlag4]);
  useEffect(() => {
    if (ev1 !== null) {
      checkDisabled();
    }
  }, [rep1, rep2, rep3, rep4]);
  useEffect(() => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  }, [openFlag, openFlag3, openFlag4]);
  /*table styleee*/
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const useStyles = makeStyles({
    table: {
      minWidth: 700,
    },
    paper: {
      elevation: 50,
    },
  });

  const classes = useStyles();

  const onEdit2 = (eve) => {
    // dispatch(setEditUser());
    setCrmId2(eve._id);
    if (eve.status === "Actif") {
      setswitched(true);
    } else setswitched(false);
    // console.log("user._id", eve.titleEv);
    setEv1(eve);
    setOpenFlag4(true);
    //  setCrmId(crm._id);
    //  soldeTotalDebit2 = "0";
    //  soldeTotalCredit2 = "0";
    //  calcSoldCred(user);
    //  calcSoldDeb(user);
    //  dispatch(setEditCrmuSoldDeb(soldeTotalDebit2));
    //  dispatch(setEditCrmuSoldCred(soldeTotalCredit2));
    // window.location.assign("/#/gestionfournisseurdetail");
    // console.log(userIdxEdited, user._id);
  };
  /*
  function calcDeb(user) {
    let res = "0";
    let b = 0;
    users.map((user2) => {
      if (user2.isManager) {
        user2.decaissement.map((el) => {
          if (el.destinataire_id === user._id) {
            if (isNaN(Number(el.debit))) {
              b = 0;
            } else {
              b = Number(el.debit);
            }
            res = (Number(res) + b).toFixed(2).toString();
          }
        });
      }
    });

    return res;
  }
  function calcCred(user) {
    let res = "0";
    let b = 0;

    users.map((user2) => {
      if (user2.isManager) {
        user2.decaissement.map((el) => {
          if (el.destinataire_id === user._id) {
            if (isNaN(Number(el.credit))) {
              b = 0;
            } else {
              b = Number(el.credit);
            }
            res = (Number(res) + b).toFixed(2).toString();
          }
        });
      }
    });

    return res;
  }
  function calcSoldCred(user) {
    let res = "0";
    let resc = calcCred(user);
    let resd = calcDeb(user);
    if (Number(resc) > Number(resd)) {
      res = (Number(resc) - Number(resd)).toFixed(2).toString();
    } else {
      res = "0";
    }

    soldeTotalCredit2 = (Number(soldeTotalCredit2) + Number(res))
      .toFixed(2)
      .toString();
    dispatch(setEditCrmSoldCred(soldeTotalCredit2));
    return res;
  }
  function calcSoldDeb(user) {
    let res = "";
    let resd = calcDeb(user);
    let resc = calcCred(user);

    if (Number(resc) < Number(resd)) {
      res = (Number(resd) - Number(resc)).toFixed(2).toString();
    } else {
      res = "0";
    }
    soldeTotalDebit2 = (Number(soldeTotalDebit2) + Number(res))
      .toFixed(2)
      .toString();
    dispatch(setEditCrmSoldDeb(soldeTotalDebit2));
    return res;
  }*/
  const onEdit = async () => {
    /*if (crmIdxEdited == rowId) {
      alert("Someone else is editing this row, please try later");
      return;
    } else {*/
    //console.log('redux state idx',crmIdxEdited);
    // dispatch(setEditCrm(rowId));
    setCrmId(crmId2);
    setOpenFlag4(false);
    setOpenFlag(true);
    // }
  };
  const onAdd = () => {
    setCrmId("");
    setOpenFlag(true);
  };
  const onListAffiche = () => {
    if (afficheListe) {
      setAfficheListe(false);
      setAfficheParticipe(false);
    } else {
      checkTot();
      setOpenFlag3(toggleV(openFlag3));
      setAfficheParticipe(false);
      setAfficheListe(true);
    }
  };
  /*const checkTot = async () => {
    if (!ev1.statusDeverse) {
      users.map(async (user) => {
        if (user.isAdmin) {
          user.evennements.map((ev) => {
            if (ev._id === crmId2) {
              ev.responses[0]["rep1"] = "0";
              ev.responses[0]["rep2"] = "0";
              ev.responses[0]["rep3"] = "0";
              ev.responses[0]["rep4"] = "0";
              ev.responses[0]["totalRep"] = "0";
              ev.responses.map((el) => {
                let totalRep = "";
                if (ev1.typeQ1 === "number" && ev1.priceQ1 !== "") {
                  totalRep = (
                    Number(totalRep) +
                    Number(ev1.priceQ1) * Number(el.rep1)
                  ).toString();
                }
                if (ev1.typeQ2 === "number" && ev1.priceQ2 !== "") {
                  totalRep = (
                    Number(totalRep) +
                    Number(ev1.priceQ2) * Number(el.rep2)
                  ).toString();
                }
                if (ev1.typeQ3 === "number" && ev1.priceQ3 !== "") {
                  totalRep = (
                    Number(totalRep) +
                    Number(ev1.priceQ3) * Number(el.rep3)
                  ).toString();
                }
                if (ev1.typeQ4 === "number" && ev1.priceQ4 !== "") {
                  totalRep = (
                    Number(totalRep) +
                    Number(ev1.priceQ4) * Number(el.rep4)
                  ).toString();
                }
                console.log("totalRep", totalRep);
                console.log(
                  "max affect",
                  ev1.maxAffect,
                  ev1.typeQ1,
                  ev1.priceQ1
                );

                if (ev1.maxAffect !== "") {
                  if (Number(totalRep) > Number(ev1.maxAffect)) {
                    totalRep = ev1.maxAffect;
                  }
                }
                el.totalRep = totalRep;

                if (ev1.typeQ1 === "number") {
                  ev.responses[0]["rep1"] = (
                    Number(ev.responses[0]["rep1"]) + Number(el.rep1)
                  ).toString();
                }
                if (ev1.typeQ2 === "number") {
                  ev.responses[0]["rep2"] = (
                    Number(ev.responses[0]["rep2"]) + Number(el.rep2)
                  ).toString();
                }
                if (ev1.typeQ3 === "number") {
                  ev.responses[0]["rep3"] = (
                    Number(ev.responses[0]["rep3"]) + Number(el.rep3)
                  ).toString();
                }
                if (ev1.typeQ3 === "number") {
                  ev.responses[0]["rep4"] = (
                    Number(ev.responses[0]["rep4"]) + Number(el.rep4)
                  ).toString();
                }
                ev.responses[0]["totalRep"] = (
                  Number(ev.responses[0]["totalRep"]) + Number(el.totalRep)
                ).toString();
              });
            }
          });
          await dispatch(saveUser(user));
          await dispatch(loadAdmin());
        }
      });
      users.map(async (user) => {
        if (user.isAdmin) {
          user.evennements.map((ev) => {
            if (ev._id === crmId2) {
              setEv1(ev);
            }
          });
        }
      });
    }
  };
*/
  const checkTot = async () => {
    // 1️⃣ Si l'événement est déjà déversé, on ne fait rien
    if (ev1.statusDeverse) return;
    const refreshedEvennements2 = await keepEvennement2();
    setEvennements(refreshedEvennements2);
    // 2️⃣ Récupérer l’admin et l’événement ciblé
    /*const admin = users.find((u) => u.isAdmin);
    if (!admin) return;*/
    const event = refreshedEvennements2.find((e) => e._id === crmId2);
    if (!event || !Array.isArray(event.responses)) return;

    // 3️⃣ Séparer la ligne « TOTAL » et les lignes participantes
    const [totalsRow, ...participantRows] = event.responses;

    // 4️⃣ Calculer totalRep pour chaque participant
    const updatedRows = participantRows.map((row) => {
      // calcul du sous‑total pour cette ligne
      let subtotal = 0;
      const questions = [
        { qty: row.rep1, type: ev1.typeQ1, price: ev1.priceQ1 },
        { qty: row.rep2, type: ev1.typeQ2, price: ev1.priceQ2 },
        { qty: row.rep3, type: ev1.typeQ3, price: ev1.priceQ3 },
        { qty: row.rep4, type: ev1.typeQ4, price: ev1.priceQ4 },
      ];
      questions.forEach(({ qty, type, price }) => {
        if (type === "number" && price && qty) {
          subtotal += Number(price) * Number(qty);
        }
      });
      // plafonnement si maxAffect défini
      if (ev1.maxAffect) {
        subtotal = Math.min(subtotal, Number(ev1.maxAffect));
      }
      return {
        ...row,
        totalRep: subtotal.toString(),
      };
    });

    // 5️⃣ Recalculer la ligne TOTAL en sommant toutes les réponses
    const sums = updatedRows.reduce(
      (acc, row) => ({
        rep1: acc.rep1 + Number(row.rep1),
        rep2: acc.rep2 + Number(row.rep2),
        rep3: acc.rep3 + Number(row.rep3),
        rep4: acc.rep4 + Number(row.rep4),
        totalRep: acc.totalRep + Number(row.totalRep),
      }),
      { rep1: 0, rep2: 0, rep3: 0, rep4: 0, totalRep: 0 },
    );
    const newTotalsRow = {
      ...totalsRow,
      rep1: sums.rep1.toString(),
      rep2: sums.rep2.toString(),
      rep3: sums.rep3.toString(),
      rep4: sums.rep4.toString(),
      totalRep: sums.totalRep.toString(),
    };

    // 6️⃣ Créer une copie propre de l'événement avec les totaux recalculés
    const updatedEvent = {
      ...event,
      responses: [newTotalsRow, ...updatedRows],
    };

    await updateEvennement2(updatedEvent);

    const refreshedEvennements = await keepEvennement2();
    setEvennements(refreshedEvennements);

    const refreshedEvent = refreshedEvennements.find((e) => e._id === crmId2);
    if (refreshedEvent) setEv1(refreshedEvent);
  };

  useEffect(() => {
    if (afficheParticipe) {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [afficheParticipe]);

  const onParticipe = () => {
    if (!ev1.statusDeverse) {
      if (afficheParticipe) {
        setAfficheListe(false);
        setAfficheParticipe(false);
      } else {
        setAfficheListe(false);
        setAfficheParticipe(true);
      }
    }
  };
  const saveParticipant = async () => {
    // 1️⃣ Calcul du total
    const prices = [
      { qty: rep1, price: ev1.priceQ1, type: ev1.typeQ1 },
      { qty: rep2, price: ev1.priceQ2, type: ev1.typeQ2 },
      { qty: rep3, price: ev1.priceQ3, type: ev1.typeQ3 },
      { qty: rep4, price: ev1.priceQ4, type: ev1.typeQ4 },
    ];

    let totalRep = prices.reduce((sum, { qty, price, type }) => {
      if (type === "number" && price !== "" && qty !== "") {
        return sum + Number(price) * Number(qty);
      }
      return sum;
    }, 0);

    // 1bis️⃣ Plafonnement si besoin
    if (ev1.maxAffect && totalRep > Number(ev1.maxAffect)) {
      totalRep = Number(ev1.maxAffect);
    }

    console.log("totalRep", totalRep);

    // 2️⃣ Récupérer l’admin et l’événement
    /*const admin = users.find((u) => u.isAdmin);
    if (!admin) return;*/

    const event = evennements.find((e) => e._id === crmId2);

    // 3️⃣ Vérifier doublon
    const already = event.responses.some(
      (r) => r.repId === participantId.value,
    );
    if (already) {
      return confirmAlert({
        title: "Participant déjà inscrit",
        message: `Le participant ${participantId.label} est déjà inscrit.`,
        buttons: [{ label: "OK", onClick: () => {} }],
      });
    }

    // 4️⃣ Ajouter la nouvelle réponse
    const newResponse = {
      rep1,
      rep2,
      rep3,
      rep4,
      repId: participantId.value,
      nameId: participantId.label,
      totalRep: totalRep.toString(),
      dateRep: moment().format("YYYY-MM-DD"),
    };
    const updatedEvent = {
      ...event,
      responses: [...event.responses, newResponse],
    };

    await updateEvennement2(updatedEvent);
    setEv1(updatedEvent);
    const refreshedEvennements = await keepEvennement2();
    setEvennements(refreshedEvennements);
    // 6️⃣ Préparer le contenu de l’email
    const htmlBody = `
      <div style="font-family: Arial, sans-serif; font-size: 15px; color: #333;">
        <p>Bonjour <strong>${loggedInUser.firstName} ${
          loggedInUser.lastName
        }</strong>,</p>
        <p>Votre inscription à l'événement <strong>${
          ev1.titleEv
        }</strong> du ${moment(ev1.dateEv).format(
          "DD/MM/YYYY",
        )} pour le participant <strong>${
          participantId.label
        }</strong> a bien été enregistrée.</p>
        <p><strong>Montant total :</strong> ${totalRep} shekels</p>
        <p>Vous pouvez payer votre participation en cliquant sur le lien suivant :</p>
        <p>
          <a href="${
            ev1.linkPay
          }" target="_blank" style="display:inline-block;padding:10px 20px;background-color:#007BFF;color:#fff;text-decoration:none;border-radius:5px;">
            Payer maintenant
          </a>
        </p>
        <hr/>
        ${ev1.q1 ? `<p>${ev1.q1} : <strong>${rep1}</strong></p>` : ""}
        ${ev1.q2 ? `<p>${ev1.q2} : <strong>${rep2}</strong></p>` : ""}
        ${ev1.q3 ? `<p>${ev1.q3} : <strong>${rep3}</strong></p>` : ""}
        ${ev1.q4 ? `<p>${ev1.q4} : <strong>${rep4}</strong></p>` : ""}
        <p style="margin-top:30px;">Bien cordialement,<br/>L’équipe de BET YOSSEF HAIM</p>
      </div>
    `;

    const textBody =
      `Bonjour ${loggedInUser.firstName} ${loggedInUser.lastName},\n\n` +
      `Votre inscription à l'événement "${ev1.titleEv}" du ${moment(
        ev1.dateEv,
      ).format("DD/MM/YYYY")} pour le participant ${
        participantId.label
      } a bien été enregistrée.\n` +
      `Montant total : ${totalRep} shekels.\n\n` +
      `Pour payer : ${ev1.linkPay}\n\n` +
      `Réponses :\n` +
      (ev1.q1 ? `- ${ev1.q1} : ${rep1}\n` : "") +
      (ev1.q2 ? `- ${ev1.q2} : ${rep2}\n` : "") +
      (ev1.q3 ? `- ${ev1.q3} : ${rep3}\n` : "") +
      (ev1.q4 ? `- ${ev1.q4} : ${rep4}\n` : "") +
      `\nBien cordialement,\nL’équipe de BET YOSSEF HAIM`;

    // 7️⃣ Envoyer les emails sans bloquer l'inscription
    try {
      if (!loggedInUser.isManager) {
        await sendEmail({
          to: loggedInUser.email,
          subject: `Inscription confirmée – ${ev1.titleEv}`,
          text: textBody,
          html: htmlBody,
        });
      }

      await sendEmail({
        to: SENDGRID_MAILFROM1,
        subject: `${participantId.label} inscrit(e) à ${ev1.titleEv}`,
        text: textBody,
        html: htmlBody,
      });
    } catch (error) {
      console.error("Erreur lors de l'envoi des emails d'inscription :", error);
    }

    // 8️⃣ Feedback utilisateur
    confirmAlert({
      title: "Confirmation d'inscription",
      message: `Le participant ${participantId.label} est bien inscrit.`,
      buttons: [
        {
          label: "OK",
          onClick: () => {
            setRep1("");
            setRep2("");
            setRep3("");
            setRep4("");
            setParticipantId(null);
            setBolsave(true);
          },
        },
      ],
    });

    // 9️⃣ Recalcul des totaux dans l'UI
    //checkTot();
  };

  /*const saveParticipant = () => {
  
    let totalRep = "";
    if (ev1.typeQ1 === "number" && ev1.priceQ1 !== "") {
      totalRep = (
        Number(totalRep) +
        Number(ev1.priceQ1) * Number(rep1)
      ).toString();
    }
    if (ev1.typeQ2 === "number" && ev1.priceQ2 !== "") {
      totalRep = (
        Number(totalRep) +
        Number(ev1.priceQ2) * Number(rep2)
      ).toString();
    }
    if (ev1.typeQ3 === "number" && ev1.priceQ3 !== "") {
      totalRep = (
        Number(totalRep) +
        Number(ev1.priceQ3) * Number(rep3)
      ).toString();
    }
    if (ev1.typeQ4 === "number" && ev1.priceQ4 !== "") {
      totalRep = (
        Number(totalRep) +
        Number(ev1.priceQ4) * Number(rep4)
      ).toString();
    }
    console.log("totalRep", totalRep);
    if (ev1.maxAffect !== "") {
      if (Number(totalRep) > Number(ev1.maxAffect)) {
        totalRep = ev1.maxAffect;
      }
    }
    let saveOk = true;
    users.map((user) => {
      if (user.isAdmin) {
        user.evennements.map((ev) => {
          if (ev._id === crmId2) {
            ev.responses.map((el) => {
              if (el.repId === participantId.value) {
                saveOk = false;
              }
            });
          }
        });
      }
    });
    if (saveOk) {
      let ResponsesNew = [];
      users.map((user) => {
        if (user.isAdmin) {
          user.evennements.map((ev) => {
            if (ev._id === crmId2) {
              ResponsesNew = ev.responses;
              ResponsesNew.push({
                rep1: rep1,
                rep2: rep2,
                rep3: rep3,
                rep4: rep4,
                repId: participantId.value,
                nameId: participantId.label,
                totalRep: totalRep,
                dateRep: moment().format("YYYY-MM-DD"),
              });

              ev.responses = ResponsesNew;
              dispatch(saveUser(user));
            }
          });
        }
      });
    }

    if (!saveOk) {
      confirmAlert({
        title: "participant deja inscrit",
        message:
          "le participant " +
          participantId.label +
          " est deja inscrit, vous ne pouvez plus modifier, merci de contacter l'administrateur le cas echeant...",
        buttons: [
          {
            label: "ok",
            onClick: () => {},
          },
        ],
      });
    } else {
      if (!loggedInUser.isManager) {
        sendEmail({
          to: loggedInUser.email,
          subject: "inscription a l'evennement : " + ev1.titleEv,
          text:
          "bonjour " +
          loggedInUser.firstName +
          " " +
          loggedInUser.lastName +
          " votre inscription a l'evennement  " +
          ev1.titleEv +
          " le " +
          moment(ev1.dateEv).format("DD/MM/YYYY") +
          " concernant le participant : " +
          participantId.label +
          " a bien été enregistrée. Le cout total de votre participation est de : " +
          totalRep +
          " shekels , merci",

          html: `<p>bonjour <strong>${loggedInUser.firstName} ${
            loggedInUser.lastName
          },</strong><br><br> Votre inscription a l'evennement ${
            ev1.titleEv
          } le ${moment(ev1.dateEv).format(
            "DD/MM/YYYY"
          )}  concernant le participant : ${
            participantId.label
          }  a bien été enregistrée.<br><br>Le cout total de votre participation est de : <strong>${totalRep} shekel</strong> <br><br>Vous pouvez payer votre participation en cliquant sur le lien suivant : ${
            ev1.linkPay
          } 
          <br>${ev1.q1} : <strong>${rep1}</strong>
          <br>${ev1.q2} : <strong>${rep2}</strong>
          <br>${ev1.q3} : <strong>${rep3}</strong>
          <br>${ev1.q4} : <strong>${rep4}</strong>
          <br><br>L'equipe de BET YOSSEF HAIM vous remercie</p>`,
        });
      }
      sendEmail({
        to: SENDGRID_MAILFROM1,
        subject:
          participantId.label +
          "est inscrit(e) a l'evennement : " +
          ev1.titleEv,
        text:
          "bonjour " +
          loggedInUser.firstName +
          " " +
          loggedInUser.lastName +
          " votre inscription a l'evennement  " +
          ev1.titleEv +
          " le " +
          moment(ev1.dateEv).format("DD/MM/YYYY") +
          " concernant le participant : " +
          participantId.label +
          " a bien été enregistrée. Le cout total de votre participation est de : " +
          totalRep +
          " shekels , merci",

        html: `<p>bonjour <strong>${loggedInUser.firstName} ${
          loggedInUser.lastName
        },</strong><br><br> Votre inscription a l'evennement ${
          ev1.titleEv
        } le ${moment(ev1.dateEv).format(
          "DD/MM/YYYY"
        )}  concernant le participant : ${
          participantId.label
        }  a bien été enregistrée .<br><br>Le cout total de votre participation est de : <strong>${totalRep} shekel</strong> <br><br>Vous pouvez payer votre participation en cliquant sur le lien suivant : ${
          ev1.linkPay
        } 
        <br><br>${ev1.q1} : <strong>${rep1}</strong>
          <br>${ev1.q2} : <strong>${rep2}</strong>
          <br>${ev1.q3} : <strong>${rep3}</strong>
          <br>${ev1.q4} : <strong>${rep4}</strong>
          <br><br>L'equipe de BET YOSSEF HAIM vous remercie</p>`,
      });

      confirmAlert({
        title: "confirmation d'inscription",
        message: "le participant " + participantId.label + " est bien inscrit",
        onClickOutside: () => {
          // même code que dans votre bouton “ok”
          setRep1("");
          setRep2("");
          setRep3("");
          setRep4("");
          setParticipantId(null);
          setBolsave(true);
        },

        buttons: [
          {
            label: "ok",
            onClick: () => {
              setRep1("");
              setRep2("");
              setRep3("");
              setRep4("");
              setParticipantId(null);
              setBolsave(true);
            },
          },
        ],
      });
    }
    checkTot();
  };*/
  const calcNbPart = (ev) => {
    // Seuls les managers voient le nombre de participants
    if (!loggedInUser.isManager) return null;

    // S’assure que la liste des réponses existe et est un tableau
    const responses = Array.isArray(ev.responses) ? ev.responses : [];

    // On retire la première ligne « TOTAL » (index 0) si elle existe
    const count = Math.max(responses.length - 1, 0);

    return count;
  };

  /* const calcNbPart = (ev) => {
    if (loggedInUser.isManager) {
      let rep = 0;
      try {
        rep = ev.responses.length - 1;
      } catch (err) {
        rep = 0;
      }
      return rep;
    } else {
      return null;
    }
  };*/
  const deverse = async () => {
    if (!ev1 || !Array.isArray(ev1.responses)) return;

    const participantResponses = ev1.responses.filter(
      (r) => r.repId && r.repId !== "TOTAL GENERAL",
    );

    for (const response of participantResponses) {
      await sendSaisie2({
        crmId: response.repId,
        debit: response.totalRep || "0",
        event: `participation ${ev1.titleEv}`,
        dateEvent: moment(ev1.dateEv).format(),
        credit: "0",
        mode: "",
        destinataire_id: "",
        destinataire: "",
      });

      await updateCrmDateMaj2(response.repId);
    }

    await dispatch(loadCrms());
  };

  /* const deverse = () => {
    crms.map((crm) => {
      ev1.responses.map((el) => {
        if (el.repId === crm._id) {
          let saisieNew = crm.saisie;
          saisieNew.push({
            debit: el.totalRep !== "" ? el.totalRep : "0",
            event: "participation " + ev1.titleEv,
            dateEvent: moment(ev1.dateEv).format(),
            credit: "0",
            mode: "",
            destinataire_id: "",
            destinataire: "",
          });

          crm.saisie = saisieNew;
          crm.dateMaj = moment().format();
          dispatch(saveCrm(crm));
        }
      });
    });
    dispatch(loadCrms());
  };*/

  const onDeverse = () => {
    // 1️⃣ Récupérer l'admin et l'événement ciblé
    /*const admin = users.find((u) => u.isAdmin);
    if (!admin) return;*/
    const event = evennements.find((e) => e._id === crmId2);
    if (!event) return;

    // 2️⃣ Si on n'a pas encore déversé → déversement
    if (!event.statusDeverse) {
      confirmAlert({
        title: "Confirmation du déversement en compta",
        message:
          "Cette action est irréversible, vous ne pourrez plus modifier l’événement. Confirmez-vous ?",
        buttons: [
          {
            label: "Oui",
            onClick: async () => {
              // ⬇️ Créer une copie propre de l'événement modifié
              const updatedEvent = {
                ...event,
                status: "Inactif",
                statusDeverse: true,
              };

              setswitched(false);
              setEv1(updatedEvent);

              // 📝 Persister dans la collection evennements
              await updateEvennement2(updatedEvent);
              const refreshedEvennements = await keepEvennement2();
              setEvennements(refreshedEvennements);
              // 💸 Enregistrer le déversement dans les CRMs
              await deverse();

              // 🔄 Réinitialiser l'affichage
              retour();
            },
          },
          { label: "Non", onClick: () => {} },
        ],
      });

      // 3️⃣ Sinon, on réinitialise l’événement
    } else {
      confirmAlert({
        title: "Confirmation de la réinitialisation",
        message:
          "Cette action est irréversible et supprimera toutes les données des participants. Confirmez-vous ?",
        buttons: [
          {
            label: "Oui",
            onClick: async () => {
              // ⬇️ Remettre la réponse « TOTAL GENERAL » à zéro
              const updatedEvent = {
                ...event,
                responses: [
                  {
                    rep1: "",
                    rep2: "",
                    rep3: "",
                    rep4: "",
                    repId: "",
                    nameId: "TOTAL GENERAL",
                    totalRep: "",
                    dateRep: "",
                  },
                ],
                statusDeverse: false,
              };

              setEv1(updatedEvent);

              // 📝 Persister dans la collection evennements
              await updateEvennement2(updatedEvent);
              const refreshedEvennements = await keepEvennement2();
              setEvennements(refreshedEvennements);
              // 🔄 Réinitialiser l'affichage
              retour();
            },
          },
          { label: "Non", onClick: () => {} },
        ],
      });
    }
  };

  /* const onDeverse = () => {
    if (!ev1.statusDeverse) {
      confirmAlert({
        title: "confirmation du deversement en compta ?",
        message:
          "cette action est irreversible, vous ne pourrez plus activer et modifier l'evennement, confirnez-vous ? ",
        buttons: [
          {
            label: "Oui",
            onClick: () => {
              setswitched(false);
              users.map((user) => {
                if (user.isAdmin) {
                  user.evennements.map((el, index) => {
                    if (el._id === crmId2) {
                      el.status = "Inactif";
                      el.statusDeverse = true;
                      setEv1(el);
                      dispatch(saveUser(user));
                    }
                  });
                }
              });
              retour();
              deverse();
            },
          },
          {
            label: "Non",
            onClick: () => {},
          },
        ],
      });
    } else {
      confirmAlert({
        title: "confirmation la reinitialisation ?",
        message:
          "cette action est irreversible, supprimera toute les donness des participants a l'evennement, confirnez-vous ? ",
        buttons: [
          {
            label: "Oui",
            onClick: () => {
              users.map((user) => {
                if (user.isAdmin) {
                  user.evennements.map((el, index) => {
                    if (el._id === crmId2) {
                      //el.status = "Inactif";
                      el.responses = [
                        {
                          rep1: "",
                          rep2: "",
                          rep3: "",
                          rep4: "",
                          repId: "",
                          nameId: "TOTAL GENERAL",
                          totalRep: "",
                          dateRep: "",
                        },
                      ];
                      el.statusDeverse = false;
                      setEv1(el);
                      dispatch(saveUser(user));
                    }
                  });
                }
              });
              retour();
            },
          },
          {
            label: "Non",
            onClick: () => {},
          },
        ],
      });
    }
  };*/

  const onHandleSwitchChange = async () => {
    // 1️⃣ Récupérer l’admin et l’événement ciblé
    /*const admin = users.find((u) => u.isAdmin);
    if (!admin) return;*/

    const event = evennements.find((e) => e._id === crmId2);
    if (!event) return;

    // 2️⃣ Déterminer le nouveau statut sans modifier directement l'événement original
    const newStatus = event.status === "Actif" ? "Inactif" : "Actif";

    const updatedEvent = {
      ...event,
      status: newStatus,
    };

    await updateEvennement2(updatedEvent);
    const refreshedEvennements = await keepEvennement2();
    setEvennements(refreshedEvennements);
    setswitched(newStatus === "Actif");

    // 3️⃣ Persister la mise à jour
    //  await dispatch(saveUser(updatedAdmin));

    // 4️⃣ Recharger les données
    // await dispatch(loadAdmin());
  };

  /*const onHandleSwitchChange = () => {
    if (switched === true) {
      setswitched(false);
      users.map((user) => {
        if (user.isAdmin) {
          user.evennements.map((el, index) => {
            if (el._id === crmId2) {
              el.status = "Inactif";
              dispatch(saveUser(user));
            }
          });
        }
      });
    } else {
      setswitched(true);
      users.map((user) => {
        if (user.isAdmin) {
          user.evennements.map((el, index) => {
            if (el._id === crmId2) {
              el.status = "Actif";
              dispatch(saveUser(user));
            }
          });
        }
      });
    }
  };*/
  const retour = () => {
    setCrmId2("");
    setCrmId("");
    setAfficheListe(false);
    setAfficheParticipe(false);
    setRep1("");
    setRep2("");
    setRep3("");
    setRep4("");
    setParticipantId(null);
    setBolsave(true);
    setOpenFlag4(false);
  };
  const compteur = useMemo(() => {
    return evennements.filter((ev) => ev.status === "Actif").length;
  }, [evennements]);

  /*const initCompteur = () => {
    // 1️⃣ On réinitialise le compteur
    compteur = 0;

    // 2️⃣ Parcours explicite des users et de leurs événements
    for (const user of users) {
      if (!user.isAdmin) continue;

      // Si evernnements n’existe pas ou n’est pas un tableau, on skip
      const evts = Array.isArray(user.evennements) ? user.evennements : [];
      for (const ev of evts) {
        if (ev.status === "Actif") {
          compteur += 1;
        }
      }
    }
  };/*

  /*const initCompteur = () => {
    compteur = 0;
    users.map((user) => {
      if (user.isAdmin) {
        user.evennements.map((ev) => {
          if (ev.status === "Actif") {
            compteur = compteur + 1;
          }
        });
      }
    });
  };*/
  const onDelete = () => {
    if (!ev1) return; // ou tout autre garde‑fou pertinent

    confirmAlert({
      title: "Confirmation de la suppression",
      message: "Cette action est irréversible, confirmez‑vous la suppression ?",
      buttons: [
        {
          label: "Oui",
          onClick: async () => {
            // 1️⃣ Supprimer l’événement dans la collection evennements
            await removeEvennement2(crmId2);

            // 4️⃣ Réinitialiser l’état d’affichage
            setCrmId2("");
            setOpenFlag4(false);
            setOpenFlag3((prev) => !prev);
          },
        },
        {
          label: "Non",
          onClick: () => {},
        },
      ],
    });
  };
  /*
    confirmAlert({
      title: "confirmation de la suppression",
      message: "Cette action est irreversible, confirmez-vous la suppression ?",
      buttons: [
        {
          label: "Oui",
          onClick: () => {
            // data3.splice(rowKey, 1);

            users.map((user) => {
              if (user.isAdmin) {
                user.evennements.map((el, index) => {
                  if (el._id === crmId2) {
                    user.evennements.splice(index, 1);
                    dispatch(saveUser(user));
                    setCrmId2("");
                    setOpenFlag4(false);
                    setOpenFlag3(toggleV(openFlag3));
                    // window.location.reload();
                  }
                });
              }
            });
          },
        },
        {
          label: "Non",
          onClick: () => {},
        },
      ],
    });
  };*/
  const onDelete2 = (responseToDelete) => {
    if (ev1.statusDeverse) return;

    confirmAlert({
      title: "Confirmation de la suppression",
      message: "Cette action est irréversible, confirmez-vous ?",
      buttons: [
        {
          label: "Oui",
          onClick: async () => {
            // 1️⃣ Trouver l'événement
            const event = evennements.find((e) => e._id === crmId2);
            if (!event) return;
            // 3️⃣ Filtrer les réponses sans modifier directement l'événement original
            const updatedEvent = {
              ...event,
              responses: event.responses.filter(
                (r) => r.repId !== responseToDelete.repId,
              ),
            };

            // 4️⃣ Sauvegarder l’événement mis à jour
            setEv1(updatedEvent);
            setEvennements((prev) =>
              prev.map((eventItem) =>
                eventItem._id === updatedEvent._id ? updatedEvent : eventItem,
              ),
            );
            await updateEvennement2(updatedEvent);

            await checkTot();

            const refreshedEvennements = await keepEvennement2();
            setEvennements(refreshedEvennements);

            setOpenFlag3((prev) => !prev);
          },
        },
        { label: "Non", onClick: () => {} },
      ],
    });
  };

  /*if (!ev1.statusDeverse) {
      confirmAlert({
        title: "confirmation de la suppression",
        message:
          "Cette action est irreversible, confirmez-vous la suppression ?",
        buttons: [
          {
            label: "Oui",
            onClick: async () => {
              // data3.splice(rowKey, 1);

              users.map(async (user) => {
                if (user.isAdmin) {
                  user.evennements.map(async (el) => {
                    if (el._id === crmId2) {
                      el.responses.map(async (evev, index) => {
                        if (evev.repId === ev.repId) {
                          el.responses.splice(index, 1);
                          await dispatch(saveUser(user));
                          await dispatch(loadAdmin());
                          setOpenFlag3(toggleV(openFlag3));
                          // window.location.reload();
                        }
                      });
                    }
                  });
                }
              });
              checkTot();
              // setOpenFlag3(toggleV(openFlag3));
              //await dispatch(loadAdmin());
              // retour();
            },
          },
          {
            label: "Non",
            onClick: () => {},
          },
        ],
      });

      setOpenFlag3(toggleV(openFlag3));
    }
  };*/

  const toggleV = (x) => {
    return !x;
  };
  const checkDisabled = () => {
    setBolsave(
      !(
        participantId !== null &&
        ((ev1.q1 !== "" && rep1 !== "") || ev1.q1 === "") &&
        ((ev1.q2 !== "" && rep2 !== "") || ev1.q2 === "") &&
        ((ev1.q3 !== "" && rep3 !== "") || ev1.q3 === "") &&
        ((ev1.q4 !== "" && rep4 !== "") || ev1.q4 === "")
      ),
    );
  };
  if (!loggedInUser || !loggedInUser.isApprouved)
    return (
      <div>
        <Oval className="oval" stroke="#06BCEE" fill="#06BCEE" />;
        <h3>
          {" "}
          vous n'avez pas encore été approuvé par le responsable de
          l'application, patience ...{" "}
        </h3>
      </div>
    );
  if (openFlag4) {
    // console.log("titleEv", ev1.titleEv);
    return (
      <div>
        <DashboardHeaderEvennements
          onAdd={onAdd}
          crmCount={compteur}
          crmId2={crmId2}
          retour={retour}
          titleEv={ev1.titleEv}
          linkPay={ev1.linkPay}
          detailEv={ev1.detailEv}
          afficheList={afficheListe}
          dateEv={ev1.dateEv}
          onDeverse={onDeverse}
          statusDeverse={ev1.statusDeverse}
          onEdit={onEdit}
          onDelete={onDelete}
          switched={switched}
          onlist={onListAffiche}
          onParticipe={onParticipe}
          handleChangeSwitch={onHandleSwitchChange}
        />
        {afficheParticipe && (
          <Button
            className="save-btn btn-simple animation-on-hover"
            disabled={bolSave}
            color="info"
            variant="contained"
            onClick={saveParticipant}
          >
            Sauvegarder
          </Button>
        )}
        {afficheParticipe && (
          <div className="question-container">
            <div className="question">
              <label>la participation concerne :</label>
            </div>
            <Select
              className="select1"
              placeholder="Selectionner..."
              required
              name="participant"
              onChange={(value) => {
                setParticipantId(value);
                checkDisabled();
              }}
              options={crms.map(
                (crm) =>
                  new Object({
                    value: crm._id,
                    label: crm.firstName.concat(" ", crm.lastName),
                  }),
              )}
              value={participantId}
            ></Select>
          </div>
        )}

        {(afficheListe || afficheParticipe) && ev1.q1 !== "" && (
          <div className="question-container">
            <div className="question">
              <label>{ev1.q1}</label>
            </div>
            <div className="response" hidden={afficheListe}>
              <TextField
                fullWidth
                label="votre Reponse"
                type={ev1.typeQ1}
                name="rep1"
                onChange={(value) => {
                  if (
                    Number(value.target.value) <= Number(ev1.maxiQ1) ||
                    ev1.maxiQ1 === "" ||
                    ev1.typeQ1 === "text"
                  ) {
                    setRep1(value.target.value);
                  } else {
                    alert(
                      "merci de saisir une valeur inferieure ou egale a " +
                        ev1.maxiQ1,
                    );
                  }
                }}
                value={rep1}
              />
            </div>
          </div>
        )}
        {(afficheListe || afficheParticipe) && ev1.q2 !== "" && (
          <div className="question-container">
            <div className="question">
              <label>{ev1.q2}</label>
            </div>
            <div className="response" hidden={afficheListe}>
              <TextField
                fullWidth
                label="votre Reponse"
                type={ev1.typeQ2}
                name="rep2"
                onChange={(value) => {
                  if (
                    Number(value.target.value) <= Number(ev1.maxiQ2) ||
                    ev1.maxiQ2 === "" ||
                    ev1.typeQ2 === "text"
                  ) {
                    setRep2(value.target.value);
                  } else {
                    alert(
                      "merci de saisir une valeur inferieure ou egale a " +
                        ev1.maxiQ2,
                    );
                  }
                }}
                value={rep2}
              />
            </div>
          </div>
        )}
        {(afficheListe || afficheParticipe) && ev1.q3 !== "" && (
          <div className="question-container">
            <div className="question">
              <label>{ev1.q3}</label>
            </div>
            <div className="response" hidden={afficheListe}>
              <TextField
                fullWidth
                label="votre Reponse"
                type={ev1.typeQ3}
                name="rep3"
                onChange={(value) => {
                  if (
                    Number(value.target.value) <= Number(ev1.maxiQ3) ||
                    ev1.maxiQ3 === "" ||
                    ev1.typeQ3 === "text"
                  ) {
                    setRep3(value.target.value);
                  } else {
                    alert(
                      "merci de saisir une valeur inferieure ou egale a " +
                        ev1.maxiQ3,
                    );
                  }
                }}
                value={rep3}
              />
            </div>
          </div>
        )}
        {(afficheListe || afficheParticipe) && ev1.q4 !== "" && (
          <div className="question-container">
            <div className="question">
              <label>{ev1.q4}</label>
            </div>
            <div className="response" hidden={afficheListe}>
              <TextField
                fullWidth
                label="votre Reponse"
                type={ev1.typeQ4}
                name="rep4"
                onChange={(value) => {
                  if (
                    Number(value.target.value) <= Number(ev1.maxiQ4) ||
                    ev1.maxiQ4 === "" ||
                    ev1.typeQ4 === "text"
                  ) {
                    setRep4(value.target.value);
                  } else {
                    alert(
                      "merci de saisir une valeur inferieure ou egale a " +
                        ev1.maxiQ4,
                    );
                  }
                }}
                value={rep4}
              />
            </div>
          </div>
        )}
        {afficheParticipe && (
          <Button
            className="save-btn btn-simple animation-on-hover"
            disabled={bolSave}
            color="info"
            variant="contained"
            onClick={saveParticipant}
          >
            Sauvegarder
          </Button>
        )}
        {afficheListe && (
          <Table
            id="table"
            className={`table-container ${classes.table}`}
            aria-label="customized table"
          >
            <thead className="text-center">
              <tr>
                <th>nom </th>

                <th>date de mise a jour</th>

                <th>reponse Q1 </th>
                <th>reponse Q2 </th>

                <th>reponse Q3 </th>
                <th>reponse Q4 </th>
                <th>total a payer </th>

                <th></th>
              </tr>
            </thead>
            <TableBody className="table-body">
              {ev1.responses.map((ev) => (
                <StyledTableRow key={ev.repId}>
                  <StyledTableCell className="partner">
                    {ev.nameId}
                  </StyledTableCell>

                  <StyledTableCell className="partner">
                    {ev.dateRep}
                  </StyledTableCell>

                  <StyledTableCell className="partner">
                    {ev.rep1}
                  </StyledTableCell>

                  <StyledTableCell className="partner">
                    {ev.rep2}
                  </StyledTableCell>
                  <StyledTableCell className="partner">
                    {ev.rep3}
                  </StyledTableCell>

                  <StyledTableCell className="partner">
                    {ev.rep4}
                  </StyledTableCell>
                  <StyledTableCell className="partner">
                    {ev.totalRep}
                  </StyledTableCell>
                  {!ev1.statusDeverse && ev.nameId !== "TOTAL GENERAL" && (
                    <StyledTableCell className="crud-icons">
                      <i
                        onClick={() => {
                          onDelete2(ev);
                        }}
                        className="fas fa-trash-alt"
                      ></i>
                    </StyledTableCell>
                  )}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    );
  }
  return (
    <div>
      {openFlag && <Modal8Evennement crmId={crmId} />}
      {/*initCompteur()*/}
      <DashboardHeaderEvennements
        onAdd={onAdd}
        crmCount={compteur}
        crmId2={""}
        retour={retour}
      />

      <div className="img-header-container2 flex">
        {evennements.map(
          (evennement) =>
            (evennement.status === "Actif" || loggedInUser.isManager) && (
              <Col lg="3" md="6">
                <Card className="card-stats" key={evennement._id}>
                  <CardBody
                    className="testCard"
                    onClick={() => onEdit2(evennement)}
                  >
                    <Row>
                      <Col xs="5">
                        <div
                          className={
                            evennement.status === "Actif"
                              ? "info-icon text-center icon-success"
                              : "info-icon text-center icon-danger"
                          }
                        >
                          <i style={{ fontSize: "16px" }}>
                            {calcNbPart(evennement)}
                          </i>
                        </div>
                      </Col>
                      <Col xs="7">
                        <div className="numbers">
                          <p className="card-category">
                            ev num {evennement._id}
                          </p>
                          <CardTitle tag="h4">{evennement.titleEv}</CardTitle>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardFooter>
                    <hr />
                    <div className="stats">
                      <i className="tim-icons icon-sound-wave" />
                    </div>
                  </CardFooter>
                </Card>
              </Col>
            ),
        )}
      </div>
      {}
    </div>
  );
}
